/* Nobsci landing — shared behaviours (scroll reveal). Ported from reference site. */
(function () {
  function initReveal() {
    var els = document.querySelectorAll('.nbs-reveal:not(.in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }
  // Re-scan when sections are added/edited in the theme editor.
  document.addEventListener('shopify:section:load', initReveal);
})();
